import { useExtendedWarrantyContext } from '@extendedWarranty/contexts/ExtendedWarrantyContext';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import React from 'react';

export type EWFileDropzoneAreaProps = {
    text?: string;
    icon?: React.ReactNode;
    className?: string;
};

const EWFileDropzoneArea = ({
    text = 'Drop Files to Upload',
    icon = <FileUploadOutlinedIcon className="size-16" />,
    className = '',
}: EWFileDropzoneAreaProps) => {
    const {
        dropzoneState,
        formik: { values },
    } = useExtendedWarrantyContext();

    const { getRootProps, getInputProps, isDragActive } = dropzoneState ?? {};

    return (
        <div className={clsx(className)}>
            <div
                className={clsx(
                    'rounded-sm flex flex-col items-center justify-center h-full border-2 md:border-0 border-spanish-blue ring-spanish-blue bg-bleached-silk px-8 text-auro-metal-saurus py-20',
                    { 'ring-2 ring-spanish-blue/80': isDragActive }
                )}
                {...getRootProps?.()}
            >
                <input {...getInputProps?.()} />
                <Box sx={{ color: (theme) => theme.palette['neutral-800'].main }} className="text-center">
                    <div className="flex flex-col gap-5 items-center">
                        {icon}
                        <div className="text-center">
                            <Typography className="hidden md:block" fontWeight={700} variant="h5">
                                {isDragActive ? 'Drop Files here...' : text}
                            </Typography>
                            <Typography className="md:hidden block" fontWeight={700} variant="h5">
                                Choose Files
                            </Typography>
                            {!values.extendedWarrantyFiles ||
                                (values.extendedWarrantyFiles.length == 0 && <Typography>No Files Chosen</Typography>)}
                        </div>
                    </div>
                </Box>
            </div>
        </div>
    );
};

export { EWFileDropzoneArea };
